import React from "react";
import { Col, Container, Row, Card } from "react-bootstrap";
import { PALETTE } from "../../common/ThemeConstants";
import DocsHeader from "../components/DocsHeader";
import ContainerResponsive from "../../common/components/ContainerResponsive";

export default function PrivacyPolicy() {
  const sectionStyle = {
    marginBottom: "2.5rem",
    padding: "1.5rem",
    borderRadius: "8px",
    backgroundColor: PALETTE.LIGHTGRAY,
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)"
  };

  const titleStyle = {
    color: PALETTE.SECONDARYCOLOR,
    marginBottom: "1rem",
    fontWeight: "600"
  };

  const subtitleStyle = {
    color: PALETTE.MAINCOLOR,
    marginTop: "1.5rem",
    marginBottom: "0.75rem",
    fontWeight: "500"
  };

  const linkStyle = {
    fontWeight: "bold",
    color: PALETTE.MAINCOLOR,
    textDecoration: "none",
    transition: "color 0.2s ease"
  };

  return (
    <>
      <DocsHeader />
      <ContainerResponsive>
        <Container>
          <Row style={{ color: PALETTE.DARK }}>
            <Col>
              <div className="text-center mb-5">
                <h1 style={{ fontWeight: "700", color: PALETTE.SECONDARYCOLOR }}>Informativa sulla Privacy</h1>
                <h5 style={{ color: PALETTE.DARKGRAY }}>
                  Ultimo aggiornamento: 2 Aprile 2025
                </h5>
              </div>

              <Card className="mb-4 border-0" style={{ backgroundColor: PALETTE.LIGHTGRAYKINDATRANSPARENT }}>
                <Card.Body className="p-4">
                  <h5 style={{ color: PALETTE.SECONDARYCOLOR }}>Sommario</h5>
                  <p>
                    La presente informativa descrive come Federico Bartoli PT raccoglie, utilizza e protegge i tuoi dati personali quando utilizzi il nostro sito web e i nostri servizi. Rispettiamo la tua privacy e ci impegniamo a proteggere i tuoi dati personali in conformità con il Regolamento Generale sulla Protezione dei Dati (GDPR) e altre leggi sulla privacy applicabili.
                  </p>
                </Card.Body>
              </Card>

              <div style={sectionStyle}>
                <h2 style={titleStyle}>1. Titolare del Trattamento</h2>
                <p>
                  Il titolare del trattamento dei dati personali è Federico Bartoli PT, con sede in Italia. Per qualsiasi domanda relativa alla presente informativa sulla privacy o alle nostre pratiche in materia di dati, puoi contattarci all'indirizzo email: <a href="mailto:fedebartopt@gmail.com" style={linkStyle}>fedebartopt@gmail.com</a>.
                </p>
              </div>

              <div style={sectionStyle}>
                <h2 style={titleStyle}>2. Raccolta e Utilizzo delle Informazioni</h2>

                <h4 style={subtitleStyle}>2.1 Informazioni durante la navigazione</h4>
                <p>
                  Quando visiti il sito web Federico Bartoli PT senza creare un account, non raccogliamo alcuna informazione personale identificativa. Utilizziamo solo cookie essenziali per garantire il corretto funzionamento del sito.
                </p>

                <h4 style={subtitleStyle}>2.2 Informazioni da utenti con un account</h4>
                <p>
                  Quando crei un account sulla nostra piattaforma, raccogliamo le seguenti informazioni personali necessarie per fornirti i nostri servizi:
                </p>
                <ul>
                  <li><strong>Dati identificativi:</strong> nome, cognome, data di nascita</li>
                  <li><strong>Dati di contatto:</strong> indirizzo email</li>
                  <li><strong>Dati fiscali:</strong> codice fiscale, indirizzo di fatturazione</li>
                  <li><strong>Dati fisici:</strong> sesso, altezza, peso</li>
                </ul>

                <h4 style={subtitleStyle}>2.3 Finalità del trattamento</h4>
                <p>
                  Utilizziamo i tuoi dati personali per le seguenti finalità:
                </p>
                <ul>
                  <li>Creare e gestire il tuo account utente</li>
                  <li>Autenticare il tuo accesso alla piattaforma</li>
                  <li>Fornirti piani di allenamento personalizzati in base alle tue caratteristiche fisiche</li>
                  <li>Monitorare i tuoi progressi di allenamento</li>
                  <li>Emettere fatture elettroniche per i servizi acquistati</li>
                  <li>Fornirti assistenza clienti</li>
                  <li>Migliorare i nostri servizi</li>
                </ul>

                <h4 style={subtitleStyle}>2.4 Base giuridica del trattamento</h4>
                <p>
                  Il trattamento dei tuoi dati personali si basa su:
                </p>
                <ul>
                  <li><strong>Esecuzione del contratto:</strong> il trattamento è necessario per l'esecuzione del contratto di cui sei parte (fornitura di servizi di personal training)</li>
                  <li><strong>Obblighi legali:</strong> il trattamento è necessario per adempiere agli obblighi legali (es. emissione di fatture)</li>
                  <li><strong>Consenso:</strong> per specifiche finalità di trattamento, quando richiesto</li>
                  <li><strong>Legittimo interesse:</strong> per migliorare i nostri servizi e garantire la sicurezza della piattaforma</li>
                </ul>
              </div>

              <div style={sectionStyle}>
                <h2 style={titleStyle}>3. Condivisione delle Informazioni</h2>
                <p>
                  Le tue informazioni personali non vengono vendute, scambiate o trasferite a terzi, ad eccezione dei seguenti casi:
                </p>
                <ul>
                  <li><strong>Fornitori di servizi:</strong> condividiamo i dati con fornitori di servizi terzi che ci aiutano a gestire il nostro business e a fornirti i nostri servizi:
                    <ul>
                      <li><strong>Stripe:</strong> per l'elaborazione dei pagamenti</li>
                      <li><strong>Fatture in Cloud:</strong> per la gestione della fatturazione elettronica</li>
                      <li><strong>Amazon Web Services (AWS):</strong> per l'archiviazione dei dati e l'hosting del sito</li>
                    </ul>
                  </li>
                  <li><strong>Obblighi legali:</strong> quando richiesto dalla legge o in risposta a richieste legittime da parte delle autorità competenti</li>
                </ul>
                <p>
                  Tutti i nostri fornitori di servizi sono vincolati da contratti che li obbligano a proteggere i tuoi dati personali e a utilizzarli solo per le finalità specificate.
                </p>
              </div>

              <div style={sectionStyle}>
                <h2 style={titleStyle}>4. Pagamenti</h2>
                <p>
                  Per l'elaborazione dei pagamenti, utilizziamo Stripe, un fornitore di servizi di pagamento sicuro. Quando effettui un pagamento, i tuoi dati di pagamento vengono trasmessi direttamente a Stripe attraverso connessioni crittografate.
                </p>
                <p>
                  Federico Bartoli PT non memorizza i dati completi della tua carta di credito. Stripe potrebbe conservare i tuoi dati di pagamento in conformità con le proprie politiche sulla privacy e i requisiti normativi.
                </p>
                <p>
                  Per ulteriori informazioni sulle pratiche di Stripe in materia di privacy, ti invitiamo a consultare la loro <a href="https://stripe.com/it/privacy" target="_blank" rel="noopener noreferrer" style={linkStyle}>Informativa sulla Privacy</a>.
                </p>
              </div>

              <div style={sectionStyle}>
                <h2 style={titleStyle}>5. Protezione dei Dati</h2>
                <p>
                  Adottiamo misure di sicurezza tecniche e organizzative appropriate per proteggere i tuoi dati personali contro l'accesso, l'uso, la divulgazione, l'alterazione o la distruzione non autorizzati, tra cui:
                </p>
                <ul>
                  <li>Crittografia delle password mediante algoritmi di hashing sicuri</li>
                  <li>Connessioni SSL/TLS per la trasmissione dei dati</li>
                  <li>Accesso limitato ai dati personali da parte del nostro personale</li>
                  <li>Monitoraggio regolare dei nostri sistemi per rilevare potenziali vulnerabilità</li>
                  <li>Backup regolari dei dati</li>
                </ul>
                <p>
                  Nonostante le nostre misure di sicurezza, è importante ricordare che nessun metodo di trasmissione su Internet o di archiviazione elettronica è sicuro al 100%. Ci impegniamo a proteggere i tuoi dati personali, ma non possiamo garantire la loro assoluta sicurezza.
                </p>
              </div>

              <div style={sectionStyle}>
                <h2 style={titleStyle}>6. Conservazione dei Dati</h2>
                <p>
                  Conserviamo i tuoi dati personali solo per il tempo necessario a soddisfare le finalità per cui sono stati raccolti, incluso l'adempimento di obblighi legali, contabili o di rendicontazione.
                </p>
                <p>
                  I dati relativi al tuo account utente vengono conservati finché mantieni un account attivo sulla nostra piattaforma. In caso di chiusura dell'account, conserveremo solo i dati necessari per adempiere ai nostri obblighi legali (ad esempio, i dati di fatturazione per il periodo richiesto dalla normativa fiscale).
                </p>
                <p>
                  I dati relativi ai tuoi allenamenti e progressi vengono conservati per tutta la durata del tuo abbonamento attivo e per un periodo di 12 mesi dopo la scadenza, per consentirti di riprendere facilmente il tuo percorso in caso di rinnovo.
                </p>
              </div>

              <div style={sectionStyle}>
                <h2 style={titleStyle}>7. Cookie e Tecnologie Simili</h2>
                <p>
                  Federico Bartoli PT utilizza cookie e tecnologie simili (come HTML5 localStorage) per migliorare l'esperienza dell'utente. I cookie sono piccoli file di testo che vengono memorizzati sul tuo dispositivo quando visiti il nostro sito web.
                </p>
                <p>
                  Utilizziamo principalmente cookie essenziali che sono necessari per il funzionamento del sito web. Questi cookie consentono funzionalità di base come la navigazione e l'accesso alle aree protette del sito.
                </p>
                <p>
                  I cookie che utilizziamo non raccolgono informazioni personali che potrebbero identificarti direttamente, ma potrebbero memorizzare un identificatore univoco per mantenere la tua sessione attiva.
                </p>
                <p>
                  Puoi configurare il tuo browser per rifiutare tutti i cookie o per avvisarti quando viene inviato un cookie. Tuttavia, se rifiuti i cookie, alcune funzionalità del nostro sito potrebbero non funzionare correttamente.
                </p>
              </div>

              <div style={sectionStyle}>
                <h2 style={titleStyle}>8. Diritti degli Utenti</h2>
                <p>
                  In conformità con il GDPR e altre leggi sulla privacy applicabili, hai i seguenti diritti riguardo ai tuoi dati personali:
                </p>
                <ul>
                  <li><strong>Diritto di accesso:</strong> hai il diritto di ottenere conferma che sia o meno in corso un trattamento di dati personali che ti riguardano e, in tal caso, di ottenere l'accesso ai dati personali</li>
                  <li><strong>Diritto di rettifica:</strong> hai il diritto di ottenere la rettifica dei dati personali inesatti che ti riguardano</li>
                  <li><strong>Diritto alla cancellazione:</strong> hai il diritto di ottenere la cancellazione dei dati personali che ti riguardano in determinate circostanze</li>
                  <li><strong>Diritto di limitazione del trattamento:</strong> hai il diritto di ottenere la limitazione del trattamento in determinate circostanze</li>
                  <li><strong>Diritto alla portabilità dei dati:</strong> hai il diritto di ricevere i dati personali che ti riguardano in un formato strutturato, di uso comune e leggibile da dispositivo automatico</li>
                  <li><strong>Diritto di opposizione:</strong> hai il diritto di opporti al trattamento dei dati personali che ti riguardano in determinate circostanze</li>
                  <li><strong>Diritto di non essere sottoposto a un processo decisionale automatizzato:</strong> hai il diritto di non essere sottoposto a una decisione basata unicamente sul trattamento automatizzato</li>
                </ul>
                <p>
                  Per esercitare questi diritti, puoi contattarci all'indirizzo email: <a href="mailto:fedebartopt@gmail.com" style={linkStyle}>fedebartopt@gmail.com</a>. Risponderemo alla tua richiesta entro 30 giorni.
                </p>
                <p>
                  Hai inoltre il diritto di presentare un reclamo a un'autorità di controllo se ritieni che il trattamento dei tuoi dati personali violi il GDPR o altre leggi sulla privacy applicabili.
                </p>
              </div>

              <div style={sectionStyle}>
                <h2 style={titleStyle}>9. Modifiche all'Informativa sulla Privacy</h2>
                <p>
                  Ci riserviamo il diritto di modificare la presente Informativa sulla Privacy in qualsiasi momento. Eventuali modifiche saranno pubblicate su questa pagina con l'indicazione della data di aggiornamento.
                </p>
                <p>
                  Ti invitiamo a rivedere periodicamente questa Informativa sulla Privacy per essere informato su come proteggiamo i tuoi dati personali. L'uso continuato dei nostri servizi dopo la pubblicazione di modifiche costituisce accettazione di tali modifiche.
                </p>
                <p>
                  In caso di modifiche sostanziali che influiscono significativamente sui tuoi diritti o sul modo in cui trattiamo i tuoi dati personali, ti informeremo tramite email o attraverso un avviso sul nostro sito web.
                </p>
              </div>

              <div style={sectionStyle}>
                <h2 style={titleStyle}>10. Contattaci</h2>
                <p>
                  Se hai domande, commenti o richieste relative alla presente Informativa sulla Privacy o alle nostre pratiche in materia di dati, non esitare a contattarci:
                </p>
                <p>
                  <strong>Email:</strong> <a href="mailto:fedebartopt@gmail.com" style={linkStyle}>fedebartopt@gmail.com</a>
                </p>
                <p>
                  Ci impegniamo a risolvere qualsiasi problema relativo alla privacy in modo equo e tempestivo.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </ContainerResponsive>
    </>
  );
}
